import Colors from "assets/Colors";
import { Page, Text, View, Document, StyleSheet } from "@react-pdf/renderer";
import moment from "moment";
import { formatPhoneNumberIntl } from "react-phone-number-input";
import { useTranslation } from "react-i18next";

function DocumentPDF({
  data,
  store,
  subcategories,
  taxes,
  users,
  nif,
  payments,
  commissions,
  withdrawals,
  currencyFormat,
}) {
  const { t } = useTranslation();

  return (
    <Document>
      <Page style={styles.body}>
        <View>
          <View style={styles.headerDrawer}>
            <Text style={styles.headerTitle}>{store?.name}</Text>
            <Text style={styles.headerInfoCompany}>{`NIF ${nif}`}</Text>
            <Text style={styles.headerInfoCompany}>
              {store?.address1} {store?.zip && `,${store.zip}`}
            </Text>
            <Text style={styles.headerInfoCompany}>
              {store?.city}, {store?.country}
            </Text>
            <Text style={styles.headerInfoCompany}>
              {store?.phone && `${formatPhoneNumberIntl(store?.phone)}`}
            </Text>
            <Text style={styles.headerInfoDescrition}>
              {moment(data?.creationDatetime).format("dddd, LL, h:mm a")}
            </Text>
          </View>
          <View style={styles.divider}> </View>
          <View>
            <Text style={[styles.subTitleBill, { textAlign: "center" }]}>
              {t(`containers.Operations.Bill.${data.type}`)}
            </Text>
          </View>
          <View style={styles.divider}> </View>
          <View>
            <View style={styles.cols}>
              <Text style={styles.pBill}>
                {t("containers.Operations.Bill.date")}
              </Text>
              <Text style={styles.pBill}>
                {moment(data?.creationDatetime).format("dddd, LL, h:mm a")}
              </Text>
            </View>
            <View style={styles.cols}>
              <Text style={styles.pBill}>
                {t("containers.Operations.Bill.employee")}
              </Text>
              <Text style={styles.pBill}>{data?.openUserName}</Text>
            </View>
            <View style={styles.cols}>
              <Text style={styles.pBill}>
                {t("containers.Operations.Bill.number")}
              </Text>
              <Text style={styles.pBill}>FA-{data?.reportNumber}</Text>
            </View>
            <View style={styles.cols}>
              <Text style={styles.pBill}>
                {t("containers.Operations.Bill.terminalNumber")}
              </Text>
              <Text style={styles.pBill}>{data?.terminalSerial}</Text>
            </View>
            <View style={styles.cols}>
              <Text style={styles.pBill}>
                {t("containers.Operations.Bill.close")}
              </Text>
              <Text style={styles.pBill}>
                {moment(data?.closeDatetime || data?.updateDatetime).format(
                  "dddd, LL, h:mm a"
                )}
              </Text>
            </View>
            <View style={styles.cols}>
              <Text style={styles.pBill}>
                {t("containers.Operations.Bill.open")}
              </Text>
              <Text style={styles.pBill}>
                {moment(data?.creationDatetime).format("dddd, LL, h:mm a")}
              </Text>
            </View>
          </View>
          <View style={styles.divider}> </View>
          {/* ********* */}
          <View style={{ ...styles.cols, marginBottom: "0px" }}>
            <Text style={[styles.subTitleBill]}>
              {t("containers.Operations.Bill.description")}
            </Text>
            <Text style={[styles.subTitleBill]}>
              {" "}
              {t("containers.Operations.Bill.quantity")}
            </Text>
            <Text style={styles.subTitleBill}>
              {" "}
              {t("containers.Operations.Bill.subTotal")}
            </Text>
          </View>

          <View style={styles.divider} />

          <View style={styles.cols}>
            <Text style={[styles.pBill, { width: "33%" }]}>
              {t("containers.Operations.Bill.totalItems")}
            </Text>
            <Text style={[styles.pBill]}>{parseInt(data?.itemQuantity)}</Text>
            <Text style={[styles.pBill, { width: "34%" }]} />
          </View>
          <View style={styles.cols}>
            <Text style={[styles.pBill]}>
              {t("containers.Operations.Bill.totalItemsReturned")}
            </Text>
            <Text style={[styles.pBill]}>
              {parseInt(data?.itemRefundQuantity)}
            </Text>
            <Text style={[styles.pBill, { width: "18%" }]} />
          </View>
          <View style={styles.cols}>
            <Text style={[styles.pBill, { width: "33%" }]}>
              {t("containers.Operations.Bill.salesoperations")}
            </Text>
            <Text style={[styles.pBill, { textAlign: "left" }]}>
              {data?.facQuantity}
            </Text>
            <Text style={[styles.pBill, { width: "34%" }]} />
          </View>
          <View style={styles.cols}>
            <Text style={[styles.pBill, { width: "17%" }]}>
              {t("containers.Operations.Bill.returns")}
            </Text>
            <Text style={[styles.pBill]}>{parseInt(data?.creQuantity)}</Text>
            <Text style={[styles.pBill, { width: "18%" }]} />
          </View>
          <View style={styles.cols}>
            <Text style={[styles.pBill]}>
              {t("containers.Operations.Bill.grossSales")}
            </Text>
            <Text style={[styles.pBill]}>
              {currencyFormat(
                (
                  parseFloat(data.facTotal) - parseFloat(data.creTotal) || 0
                ).toFixed(2)
              )}
            </Text>
          </View>
          <View style={styles.cols}>
            <Text style={[styles.pBill]}>
              {t("containers.Operations.Bill.netSales")}
            </Text>
            <Text style={[styles.pBill]}>
              {" "}
              {currencyFormat(
                (
                  parseFloat(taxes[0]?.amount2 || 0) +
                    parseFloat(taxes[1]?.amount2 || 0) +
                    parseFloat(taxes[2]?.amount2 || 0) +
                    parseFloat(taxes[3]?.amount2 || 0) || 0
                ).toFixed(2)
              )}
            </Text>
          </View>

          {taxes.map((tax) => (
            <div key={tax._id}>
              <View style={styles.cols}>
                <Text style={[styles.pBill]}>
                  {tax.description.includes("EXENTO")
                    ? tax.description.split(" ")[1]
                    : `${t(
                        "containers.Operations.Bill.taxBase"
                      )} ${tax?.description.match(/(\d+)/g)}%`}
                </Text>
                <Text style={[styles.pBill]}>
                  {currencyFormat(tax.amount2)}
                </Text>
              </View>
              <View style={styles.cols}>
                <Text style={[styles.pBill]}>{tax?.description}</Text>
                <Text style={[styles.pBill]}>
                  {currencyFormat(tax?.amount)}
                </Text>
              </View>
            </div>
          ))}

          <View style={styles.divider}> </View>
          {/* ******** */}

          {payments.map((payment) => {
            return (
              <View key={payment._id} style={styles.cols}>
                <Text style={[styles.pBill, { width: "33%" }]}>
                  {t(`containers.Operations.Bill.${payment.code}`)}
                </Text>
                <Text
                  style={[styles.pBill, { width: "33%", textAlign: "center" }]}
                >
                  {payment?.quantity}
                </Text>
                <Text
                  style={[styles.pBill, { width: "33%", textAlign: "right" }]}
                >
                  {currencyFormat(payment?.amount)}
                </Text>
              </View>
            );
          })}

          <View
            style={{
              height: "25px",
            }}
          />

          <View style={styles.cols}>
            <Text style={[styles.pBill, { width: "33%" }]}>
              {t("containers.Operations.Bill.discount")}
            </Text>
            <Text style={[styles.pBill, { width: "33%", textAlign: "center" }]}>
              {parseFloat(data?.discountQuantity)}
            </Text>
            <Text style={[styles.pBill, { width: "33%", textAlign: "right" }]}>
              {currencyFormat(data?.discountAmount)}
            </Text>
          </View>
          <View style={styles.cols}>
            <Text style={[styles.pBill, { width: "33%" }]}>
              {t("containers.Operations.Bill.quantityDiscountsReturned")}
            </Text>
            <Text style={[styles.pBill, { width: "33%", textAlign: "center" }]}>
              {parseFloat(data?.discountRefundQuantity)}
            </Text>
            <Text style={[styles.pBill, { width: "33%", textAlign: "right" }]}>
              {currencyFormat(data?.discountRefundAmount)}
            </Text>
          </View>
          <View style={styles.divider}> </View>
          {/* ******** */}
          {subcategories.map((category) => (
            <div key={category._id}>
              <View style={styles.cols}>
                <Text style={[styles.pBill, { width: "33%" }]}>
                  {category?.description}
                </Text>
                <Text
                  style={[styles.pBill, { width: "33%", textAlign: "center" }]}
                >
                  {category?.quantity}
                </Text>
                <Text
                  style={[styles.pBill, { width: "33%", textAlign: "right" }]}
                >
                  {currencyFormat(category?.amount)}
                </Text>
              </View>

              {parseInt(category?.quantity2) > 0 && (
                <View style={styles.cols}>
                  <Text style={[styles.pBill, { width: "33%" }]}>
                    {t("containers.Operations.Bill.returns")}{" "}
                    {category?.description}
                  </Text>
                  <Text
                    style={[
                      styles.pBill,
                      { width: "33%", textAlign: "center" },
                    ]}
                  >
                    {category?.quantity2}
                  </Text>
                  <Text
                    style={[styles.pBill, { width: "33%", textAlign: "right" }]}
                  >
                    {currencyFormat(category?.amount2)}
                  </Text>
                </View>
              )}
            </div>
          ))}
          <View style={styles.divider}> </View>
          {/* ******** */}

          {users.map((user, index) => (
            <div key={user._id}>
              {parseInt(user.quantity) !== 0 && (
                <View style={styles.cols}>
                  <Text style={[styles.pBill, { width: "33%" }]}>
                    {user.description}
                  </Text>
                  <Text
                    style={[
                      styles.pBill,
                      { width: "33%", textAlign: "center" },
                    ]}
                  >
                    {user.quantity}
                  </Text>
                  <Text
                    style={[styles.pBill, { width: "33%", textAlign: "right" }]}
                  >
                    {currencyFormat(user?.amount)}
                  </Text>
                </View>
              )}

              {parseInt(user.quantity2) !== 0 && (
                <View style={styles.cols}>
                  <Text style={[styles.pBill, { width: "33%" }]}>
                    {t("containers.Operations.Bill.discount")}{" "}
                    {user.description}
                  </Text>
                  <Text
                    style={[
                      styles.pBill,
                      { width: "33%", textAlign: "center" },
                    ]}
                  >
                    {user.quantity2}
                  </Text>
                  <Text
                    style={[styles.pBill, { width: "33%", textAlign: "right" }]}
                  >
                    {currencyFormat(user?.amount2)}
                  </Text>
                </View>
              )}

              {parseInt(user.quantity3) !== 0 && (
                <View style={styles.cols}>
                  <Text style={[styles.pBill, { width: "33%" }]}>
                    {t("containers.Operations.Bill.returns")} {user.description}
                  </Text>
                  <Text
                    style={[
                      styles.pBill,
                      { width: "33%", textAlign: "center" },
                    ]}
                  >
                    {user.quantity3}
                  </Text>
                  <Text
                    style={[styles.pBill, { width: "33%", textAlign: "right" }]}
                  >
                    {currencyFormat(user?.amount3)}
                  </Text>
                </View>
              )}
              {index === users.length - 1 && (
                <View style={styles.divider}> </View>
              )}
            </div>
          ))}

          {/* commissions */}
          {commissions.length > 0 && (
            <>
              <Text
                style={[
                  styles.subTitleBill,
                  { textAlign: "start", marginBottom: "10px" },
                ]}
              >
                {t("containers.Operations.Bill.commissions")}
              </Text>

              {commissions.map((commission, i) => (
                <View key={commission._id}>
                  <View style={styles.cols}>
                    <Text style={[styles.pBill, { width: "33%" }]}>
                      {commission.description}
                    </Text>
                    <Text
                      style={[
                        styles.pBill,
                        { width: "33%", textAlign: "center" },
                      ]}
                    >
                      {commission.quantity}
                    </Text>
                    <Text
                      style={[
                        styles.pBill,
                        { width: "33%", textAlign: "right" },
                      ]}
                    >
                      {currencyFormat(commission.amount)}
                    </Text>
                  </View>

                  {i === commissions.length - 1 && (
                    <View style={styles.divider}> </View>
                  )}
                </View>
              ))}
            </>
          )}

          {/* *********** */}
          <View style={styles.cols}>
            <Text style={styles.pBill}>
              {t("containers.Operations.Bill.invoicesFT")}
            </Text>
            <Text style={styles.pBill}>
              {`${data.facStartNumber} - ${data?.facEndNumber} `}
            </Text>
          </View>
          <View style={{ ...styles.cols, marginBottom: "0px" }}>
            <Text style={styles.pBill}>
              {t("containers.Operations.Bill.returnNC")}
            </Text>
            <Text style={styles.pBill}>
              {data?.creStartNumber && data?.creEndNumber
                ? `${data?.creStartNumber} - ${data?.creEndNumber}`
                : t("containers.Operations.Bill.noEmitted")}
            </Text>
          </View>
          <View style={styles.divider}> </View>
          {/* *********** */}
          <View style={{ ...styles.cols, marginBottom: "0px" }}>
            <Text style={[styles.subTitleBill, { textAlign: "start" }]}>
              {t("containers.Operations.Bill.TransactionConsolidation")}
            </Text>
            <Text style={[styles.subTitleBill, { textAlign: "end" }]}>
              {t(`containers.Operations.Bill.${data.type}`)}
            </Text>
          </View>
          <View style={styles.divider}> </View>
          {/* ******* */}
          <Text
            style={[
              styles.subTitleBill,
              { textAlign: "start", marginBottom: "10px" },
            ]}
          >
            {t("containers.Operations.Bill.cash")}
          </Text>
          <View style={styles.cols}>
            <Text style={styles.pBill}>
              {t("containers.Operations.Bill.initialCash")}
            </Text>
            <Text style={styles.pBill}>
              {currencyFormat(data?.cashStartAmount)}
            </Text>
          </View>

          {/* withdrawals */}

          {withdrawals.map((withdrawal, i) => (
            <View key={withdrawal._id}>
              <View style={styles.cols}>
                <Text style={styles.pBill}>
                  {t(`containers.Operations.Bill.${withdrawal.type}`)}
                  {withdrawal.description && ` - ${withdrawal.description}`}
                  {withdrawal.groupDescription &&
                    ` - ${withdrawal.groupDescription}`}
                </Text>
                <Text style={styles.pBill}>
                  {currencyFormat(withdrawal?.amount)}
                </Text>
              </View>

              {i === withdrawals.length - 1 && (
                <View style={styles.divider}> </View>
              )}
            </View>
          ))}

          <View style={styles.cols}>
            <Text style={styles.pBill}>
              {t("containers.Operations.Bill.cash_end")}
            </Text>
            <Text style={styles.pBill}>
              {currencyFormat(
                parseFloat(data?.cashStartAmount) + parseFloat(data?.cashAmount)
              )}
            </Text>
          </View>
          <View style={styles.cols}>
            <Text style={styles.pBill}>
              {t("containers.Operations.Bill.finalCash")}
            </Text>
            <Text style={styles.pBill}>
              {currencyFormat(data?.cashEndAmount)}
            </Text>
          </View>
          <View style={styles.cols}>
            <Text style={styles.pBill}>
              {t("containers.Operations.Bill.difference")}
            </Text>
            <Text style={styles.pBill}>
              {currencyFormat(
                data?.cashEndAmount -
                  (parseFloat(data?.cashStartAmount) +
                    parseFloat(data?.cashAmount))
              )}
            </Text>
          </View>
        </View>
        <Text
          style={styles.pageNumber}
          render={({ pageNumber, totalPages }) =>
            `${pageNumber} / ${totalPages}`
          }
          fixed
        />
      </Page>
    </Document>
  );
}

const styles = StyleSheet.create({
  body: {
    paddingTop: 35,
    paddingBottom: 65,
    paddingHorizontal: 20,
  },
  pageNumber: {
    position: "absolute",
    fontSize: 12,
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: "center",
    color: "grey",
  },
  cols: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-end",
    marginBottom: 10,
  },

  divider: {
    borderBottomWidth: 0.5,
    borderBottomColor: Colors.background_dividers,
    marginBottom: 15,
    marginTop: 15,
  },
  headerDrawer: {
    textAlign: "center",
    marginBottom: 0,
  },
  headerTitle: {
    fontSize: 16,
    fontWeight: 500,
    marginBottom: 15,
  },
  headerInfoCompany: {
    fontSize: 12,
    fontWeight: 300,
    color: Colors.text_secondary,
  },
  headerInfoDescrition: {
    fontSize: 14,
    fontWeight: 300,
    color: Colors.text_primary,
    marginBottom: 10,
    marginTop: 15,
  },
  subTitleBill: {
    fontSize: 12,
    fontWeight: 800,
    color: Colors.text_primary,
  },
  contentBill: {
    display: "flex",
    justifyContent: "center",
  },
  pBill: {
    fontSize: 10,
    fontWeight: 300,
    color: Colors.text_primary,
  },
});

export default DocumentPDF;
